import { useTranslation } from "react-i18next";
import { eventOnDate, type GoogleEvent } from "../../pages/meeting-reservations/useGoogleCalendar";
import { Modal } from "./Primitives";

export function GoogleCalendarEvents({ items, date, query, onSelect }: {
  items: GoogleEvent[];
  date: Date;
  query: string;
  onSelect: (event: GoogleEvent) => void;
}) {
  const { t, i18n } = useTranslation();
  return <>{items.filter(item => eventOnDate(item, date) && `${item.title} ${item.location}`.toLocaleLowerCase().includes(query.toLocaleLowerCase())).map(item => <button
    key={"google-" + item.id} className="calendar-booking google-calendar-event"
    onClick={event => { event.stopPropagation(); onSelect(item); }}>
    <strong>{item.allDay ? t("All day") : new Date(item.start).toLocaleTimeString(i18n.resolvedLanguage || "fr", { hour: "2-digit", minute: "2-digit" })}</strong>
    <span>{item.title || t("Untitled event")}</span><small>{t("Google Calendar")}</small>
  </button>)}</>;
}

export function GoogleCalendarEventDetails({ event, onClose, note }: {
  event: GoogleEvent;
  onClose: () => void;
  note: string;
}) {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || "fr";
  function formatDate(value: string, exclusiveEnd = false) {
    if (!event.allDay) return new Date(value).toLocaleString(locale, { dateStyle: "medium", timeStyle: "short" });
    const date = new Date(value + "T12:00:00");
    if (exclusiveEnd) date.setDate(date.getDate() - 1);
    return date.toLocaleDateString(locale);
  }
  return <Modal title={event.title || t("Untitled event")} wide className="reservation-details-modal google-event-details-modal" onClose={onClose}>
    <dl className="calendar-details">
      <div><dt>{t("Source")}</dt><dd>{t("Google Calendar")}</dd></div>
      <div><dt>{t("Start time")}</dt><dd>{formatDate(event.start)}</dd></div>
      <div><dt>{t("End time")}</dt><dd>{formatDate(event.end, true)}</dd></div>
      {event.location && <div><dt>{t("Location")}</dt><dd>{event.location}</dd></div>}
    </dl>
    <p className="calendar-event-note">{t(note)}</p>
    {event.url && <div className="modal-actions"><a className="button primary" href={event.url} target="_blank" rel="noopener noreferrer">{t("Open in Google Calendar")}</a></div>}
  </Modal>;
}
